<div class="flag-number-item-label"
     *ngIf="label"
     [title]="label">{{label}}</div>
<div class="name" *ngIf="!label">{{ empty | translate}}</div>
<div  class="flag-number-item-msisdn" *ngIf="number">
  <span class="flag-icon flag-icon-{{getNumbersCountry(number)}} m-r-sm shadow-up"></span>
  <span class="msisdn">{{ formattedNumber }}</span>
</div>
